export enum ROUTE_DM {
  HOME = 'dm',
  URI_HOME = 'dm-thread_id-index',
  URI_FACETS_CONTENT = 'dm-thread_id-index-content_type',
  URI_FACETS_MEDIA = 'dm-thread_id-index-media',
  URI_FACETS_WEDO = 'dm-thread_id-index-wedo',
  URI_MEMBERS = 'dm-thread_id-members',
}
